import { CAD_PLAN_ID, CadPlanId } from 'www-shared';
import UnifiedSignupScreenName from '../UnifiedSignupScreenName';

export default class UnifiedSignupPlan {
  public readonly plan;

  /** Ordered list of screen names for the details pages needed for this plan */
  public readonly detailPagesScreenNames: readonly UnifiedSignupScreenName[];

  public readonly planId: CadPlanId;

  public static free = new UnifiedSignupPlan({
    val: 'Free',
    detailPagesScreenNames: ['uss-details-free-1of2', 'uss-details-free-2of2'],
    planId: CAD_PLAN_ID.FREE_2016,
  });

  public static pro = new UnifiedSignupPlan({
    val: 'Pro',
    detailPagesScreenNames: ['uss-details-pro-1of2', 'uss-details-pro-2of2'],
    planId: CAD_PLAN_ID.PRO_COMPANY_TRIAL,
  });

  public static edu = new UnifiedSignupPlan({
    val: 'Edu',
    detailPagesScreenNames: ['uss-details-edu-student'],
    planId: CAD_PLAN_ID.EDU_YEARLY,
  });

  public static educator = new UnifiedSignupPlan({
    val: 'Educator',
    detailPagesScreenNames: ['uss-details-edu-educator'],
    planId: CAD_PLAN_ID.EDU_EDUCATOR,
  });

  public static standard = new UnifiedSignupPlan({
    val: 'Standard',
    detailPagesScreenNames: ['uss-details-standard'],
    planId: CAD_PLAN_ID.FREE_2016, // user is assigned Free plan on signup, then redirected to purchase standard
  })

  private static mappings: Record<string, UnifiedSignupPlan> = {
    Free: UnifiedSignupPlan.free,
    Pro: UnifiedSignupPlan.pro,
    Edu: UnifiedSignupPlan.edu,
    Educator: UnifiedSignupPlan.educator,
    Standard: UnifiedSignupPlan.standard,
  };

  private constructor({
    val,
    detailPagesScreenNames,
    planId,
  }: {
    val: string,
    detailPagesScreenNames: Array<UnifiedSignupScreenName>,
    planId: CadPlanId,
  }) {
    this.plan = val;
    this.detailPagesScreenNames = detailPagesScreenNames;
    this.planId = planId;
  }

  public static fromString(val: string | number | boolean): UnifiedSignupPlan {
    const intent = UnifiedSignupPlan.mappings[`${val}`];
    if (!intent) throw new Error(`Could not find plan with val: '${val}'`);
    return intent;
  }

  public compareTo(rhs: UnifiedSignupPlan) {
    return this.plan === rhs.plan;
  }
}
